import loadJS from 'fg-loadjs';
import $ from 'jquery';

let googleMapsState = 'initial';
let scheduledMaps = [];

function enableMap($map) {
    let center = {
        lat: parseFloat($map.data('latitude')),
        lng: parseFloat($map.data('longitude'))
    };
    let zoom = parseInt($map.data('zoom'), 10) || 16;
    let title = $map.data('title');

    let googleMap = new google.maps.Map($map[0], {
        zoom: zoom,
        center: center,
        disableDefaultUI: true,
        mapId: "739e73f01abdf71d",
    });

    new google.maps.Marker({
        position: center,
        map: googleMap,
        title: title,
        icon: '/_assets/c1dda3cd8b878b3d2d1341386e1ea699/Icons/marker.svg'
    });
}

window.googleMapsInit = function () {
    googleMapsState = 'loaded';
    scheduledMaps.forEach($map => enableMap($map));
};

function triggerMapLoad($map) {
    if (googleMapsState === 'initial') {
        scheduledMaps.push($map);
        let apiKey = $map.data('apikey');
        loadJS('https://maps.googleapis.com/maps/api/js?callback=googleMapsInit&key=' + encodeURIComponent(apiKey));
        googleMapsState = 'loading';
    } else if (googleMapsState === 'loading') {
        scheduledMaps.push($map);
    } else {
        enableMap($map);
    }
}

$('.js-map').on('click', function (e) {
    e.preventDefault();
    let mapId = '#' + $(this).data('map');
    let $map = $(mapId);
    triggerMapLoad($map);
    $(this).remove();
});

if (typeof consentApi !== 'undefined') {
    consentApi.on('enable:google-maps', ev => {
        $('.js-map').trigger('click');
    });
}
